import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { TaxPeConfigurationService } from "../../../../../services/tax-peconfiguration.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from '@angular/common';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'pe-configuration-changelog',
    templateUrl: './pe-configurationchangelog.component.html',
    styleUrls: [
        './pe-configurationchangelog.component.less',
        '../../../../../style/changelog-dialog/changelog-dialog.less'
    ],
    standalone: false
})

export class PeConfigurationChangelogComponent implements OnInit{

    public dataSource = new MatTableDataSource<PeConfigurationChanges>();
    searchString: string = '';
    originalData: PeConfigurationChanges[] = [];
    @ViewChild(MatSort) matSort = new MatSort();
    @ViewChild('tableBody') tableBody!: ElementRef;
    managementId: string = "";
    isOpenTextAreaOverlay: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<PeConfigurationChangelogComponent>
        , private taxPeConfigurationService: TaxPeConfigurationService
        , private toasterService: ToastrService
        , public datePipe: DatePipe
    )
    {
    }

    columnsToDisplay = ["date", "upn", "details"];

    ngOnInit(): void {
        this.searchString = '';
        this.originalData = [];

        this.taxPeConfigurationService.getPeConfigurationHistory(
            this,
            function (tthis: PeConfigurationChangelogComponent, result: PeConfigurationHistory) {
                tthis.tableBody.nativeElement.style.visibility = "visible";
                tthis.dataSource.data = result.changesList;
                tthis.originalData = result.changesList;
                tthis.managementId = result.managementId;
            },
            (error: any) => {
                this.toasterService.error("Unable to load Pe configuration");
            }
        );
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.matSort;
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'date':
                    return new Date(item.utcDate).getTime();
                default:
                    return item[property];
            }
        };
    }

    close() {
        this.dialogRef.close();
    }

    async updateFilteredHistory() {
        this.dataSource.data = this.filterAndShowResults(this.searchString);
    }

    filterAndShowResults(searchString: string) {
        if(searchString === "") {
            return this.originalData;
        }
        return this.originalData.filter(item => searchString === "" ? true : item.upn.toLowerCase().includes(searchString.toLowerCase())
            || item.details.toLowerCase().includes(searchString.toLowerCase()));
    }
}